import type { ComponentPropsWithRef } from "react";
import { forwardRef } from "react";
import classNames from "classnames";
import { TextRenderer } from "@/react/components/shared/BuilderUI/DefaultBlocks/Content/RichText/TextRenderer";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { parseStyles } from "@circle-react-shared/BuilderUI/utils/parseStyles";
import { defaultStyles } from "./defaultStyles";

interface H6Props extends ComponentPropsWithRef<"h6"> {
  blockPath: string;
  styles: Record<string, StyleValue>;
  text: string;
}

export const H6 = forwardRef<HTMLHeadingElement, H6Props>(
  ({ text, blockPath, styles, className, ...rest }, ref) => {
    const inlineStyles = parseStyles({ styles, defaultStyles });

    return (
      <h6
        ref={ref}
        className={classNames(
          "wb-text-h6-color wb-text-h6 wb-font-h6 wb-leading-h6 wb-tracking-h6 wb-whitespace-pre-wrap",
          className,
        )}
        style={inlineStyles}
        data-testid="builder-heading"
        {...rest}
      >
        <TextRenderer blockPath={blockPath} text={text} />
      </h6>
    );
  },
);

H6.displayName = "H6";
